/* eslint-disable */

import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import { colors } from '../../../helper/constant/colors';

function MyShop_Seller_JobToDo(props) {
  const [summary_job, setSummary_job] = useState({
    waitaccept: 0,
    mustdeliver: 0,
    ondeliver: 0,
    cancelreq: 0,
    returnreq: 0,
    income: 0,
    itemblank: 0,
    itempromotion: 0,
    // New KPIs
    todaySales: 0,
    todayOrders: 0,
    pendingIncomeAmount: 0,
    newCustomers: 0,
    bestSellers: [],
    weeklySales: [],
    urgentTasks: []
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  useEffect(() => {
    const shopId = props.permitdata.shop_id;
    const now = new Date();
    const todayStr = now.toISOString().split('T')[0];

    const myOrders = props.data_shoporderlist.filter(item => item.seller_shopid === shopId);
    const myProducts = props.data_shopitemlist.filter(item => item.shop_id === shopId);

    // 1. Existing counters
    const waitaccept = myOrders.filter(item => item.order_status === 'IV_Req' && item.api_paymentstatus === 'Success').length;
    const mustdeliver = myOrders.filter(item => (item.order_status === 'IV_Req' && item.api_paymentstatus === 'Success') || item.order_status === 'PC_Prepare' || item.order_status === 'PC_C_Cancel_Req').length;
    const ondeliver = myOrders.filter(item => ['PC_Book', 'PC_BookConfirm', 'PC_C_Book_Cancel_Req'].includes(item.order_status)).length;
    const cancelreq = myOrders.filter(item => item.order_status === 'PC_C_Cancel_Req').length;
    const returnreq = myOrders.filter(item => ['PC_RTN_Prepare', 'PC_RTN_Req', 'PC_RTN_AC', 'PC_RTN_Book', 'PC_RTN_BookConfirm'].includes(item.order_status)).length;
    const incomeOrders = myOrders.filter(item => (item.order_status === 'PC_RCV' && !item.income_paid) || (item.order_status === 'PC_RTN_RCV' && item.return_shop_income > 0 && !item.income_paid));
    const incomeCount = incomeOrders.length;
    const itemblank = myProducts.filter(item => item.status === 'OnSell' && item.isblank).length;
    const itempromotion = myProducts.filter(item => item.status === 'OnSell' && Number(item.promotion_pricenew) > 0).length;

    // 2. New KPIs logic
    const todayOrdersList = myOrders.filter(item => (item.createtime && item.createtime.startsWith(todayStr)) || (item.expiretime && item.expiretime.startsWith(todayStr)));
    const todaySales = todayOrdersList.reduce((acc, curr) => acc + Number(curr.shop_total || 0), 0);
    const todayOrders = todayOrdersList.length;
    
    // Real Pending Income: Sum income from orders where the process is done but payment to seller is pending
    const pendingIncomeAmount = incomeOrders.reduce((acc, curr) => {
      const amount = curr.order_status === 'PC_RTN_RCV' ? Number(curr.return_shop_income || 0) : Number(curr.shop_income || 0);
      return acc + amount;
    }, 0);
    
    // New Customers (approximate by unique IDs in today's orders)
    const newCustomers = new Set(todayOrdersList.map(o => o.buyer_shopid)).size;

    // Urgent Tasks list
    const urgentTasks = [];
    if (mustdeliver > 0) urgentTasks.push({ label: 'ต้องจัดส่งวันนี้', count: mustdeliver, level: 'danger', icon: 'fe-truck', link: '/myshop/seller/deliver' });
    if (waitaccept > 0) urgentTasks.push({ label: 'รอการตอบรับ', count: waitaccept, level: 'warning', icon: 'fe-check-circle', link: '/myshop/seller/deliver' });
    if (cancelreq > 0 || returnreq > 0) urgentTasks.push({ label: 'คำขอคืนสินค้า/ยกเลิก', count: cancelreq + returnreq, level: 'danger', icon: 'fe-alert-circle', link: '/myshop/seller/return' });
    if (itemblank > 0) urgentTasks.push({ label: 'สินค้าหมด/สต็อกต่ำ', count: itemblank, level: 'warning', icon: 'fe-archive', link: '/myshop/seller/myproduct?tab=สินค้าหมด' });

    // 3. Weekly Sales Calculation (Last 7 Days)
    const last7Days = [];
    const salesData = [];
    for (let i = 6; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      const dStr = d.toISOString().split('T')[0];
      const dayOrders = myOrders.filter(o => (o.createtime && o.createtime.startsWith(dStr)) || (o.expiretime && o.expiretime.startsWith(dStr)));
      const dayTotal = dayOrders.reduce((acc, curr) => acc + Number(curr.shop_total || 0), 0);
      salesData.push(dayTotal);
    }
    const maxSales = Math.max(...salesData, 1000); 
    const weeklySales = salesData.map(val => (val / maxSales) * 100);

    // 4. Best Sellers Calculation
    const productStats = {};
    myOrders.forEach(order => {
      if (order.orderitem) {
        order.orderitem.forEach(item => {
          const pid = item.productitem_id;
          if (!productStats[pid]) {
            productStats[pid] = {
              name: item.productitem_name,
              count: 0,
              imgKey: item.img1_key,
              id: item.productitem_id
            };
          }
          if (item.orderitem_pricelist) {
            item.orderitem_pricelist.forEach(p => {
              productStats[pid].count += Number(p.select || 0);
            });
          }
        });
      }
    });

    const bestSellers = Object.values(productStats)
      .sort((a, b) => b.count - a.count)
      .slice(0, 5)
      .map((p, i) => ({
        name: p.name || 'ไม่ระบุชื่อ',
        sales: p.count,
        img: p.id && p.imgKey ? `${process.env.REACT_APP_IMAGE_URL}${p.id}/${p.id}-1-${p.imgKey}.jpg` : ''
      }));

    setSummary_job({
      waitaccept, mustdeliver, ondeliver, cancelreq, returnreq, 
      income: incomeCount, itemblank, itempromotion,
      todaySales, todayOrders, pendingIncomeAmount, newCustomers,
      bestSellers, weeklySales, urgentTasks
    });

  }, [props.data_shoporderlist, props.data_shopitemlist, props.permitdata.shop_id]);

  return (
    <div className='my-0 font-inter font-th dashboard-wrapper'>
      
      {/* 1. Quick Actions Bar */}
      <div className='quick-actions-bar'>
        <Link to='/myshop/seller/newproduct' className='btn-quick-action'>
          <i className='fe-plus-circle text-primary'></i>
          <span>เพิ่มสินค้าใหม่</span>
        </Link>
        <Link to='/myshop/seller/myproduct' className='btn-quick-action'>
          <i className='fe-tag text-success'></i>
          <span>สร้างโปรโมชัน</span>
        </Link>
        <Link to='/myshop/seller/deliver' className='btn-quick-action'>
          <i className='fe-printer text-warning'></i>
          <span>พิมพ์ใบจัดส่ง</span>
        </Link>
      </div>

      {/* 2. Top Summary KPI */}
      <div className='kpi-grid-new'>
        <div className='kpi-card-new'>
          <div className='kpi-label'>ยอดขายวันนี้</div>
          <div className='kpi-value text-primary'>฿{summary_job.todaySales.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          <div className='kpi-trend trend-up'>
            <i className='fe-trending-up'></i>
            <span>วันนี้</span>
          </div>
        </div>
        <div className='kpi-card-new'>
          <div className='kpi-label'>ออเดอร์วันนี้</div>
          <div className='kpi-value'>{summary_job.todayOrders}</div>
          <div className='kpi-trend trend-up'>
            <i className='fe-shopping-bag'></i>
            <span>รายการใหม่</span>
          </div>
        </div>
        <div className='kpi-card-new'>
          <div className='kpi-label'>รายได้รอรับ</div>
          <div className='kpi-value text-warning'>฿{summary_job.pendingIncomeAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          <div className='kpi-trend text-muted'>
            <span>จาก {summary_job.income} ออเดอร์</span>
          </div>
        </div>
        <div className='kpi-card-new'>
          <div className='kpi-label'>ลูกค้าใหม่</div>
          <div className='kpi-value text-success'>{summary_job.newCustomers}</div>
          <div className='kpi-trend trend-up'>
            <i className='fe-users'></i>
            <span>ร้านค้าที่สั่งซื้อ</span>
          </div>
        </div>
      </div>

      {/* 3. Urgent Tasks Section */}
      <div className='section-container'>
        <div className='section-header-new'>
          <div className='section-title-new'>งานที่ต้องทำด่วนวันนี้</div>
          <Link to='/myshop/seller/deliver' className='text-primary font-size-13 font-weight-600'>ดูทั้งหมด</Link>
        </div>
        <div className='urgent-grid'>
          {summary_job.urgentTasks.length > 0 ? (
            summary_job.urgentTasks.map((task, i) => (
              <Link key={i} to={task.link} className={`urgent-item ${task.level}`}>
                <div className='urgent-icon'><i className={task.icon}></i></div>
                <div className='urgent-info'>
                  <div className='urgent-count'>{task.count} รายการ</div>
                  <div className='urgent-label'>{task.label}</div>
                </div>
                <i className='fe-chevron-right text-muted'></i>
              </Link>
            ))
          ) : (
            <div className='urgent-item success w-100' style={{ borderLeft: 'none', justifyContent: 'center' }}>
              <div className='urgent-label text-success'>🎉 ยินดีด้วย! คุณจัดการงานวันนี้ครบถ้วนแล้ว</div>
            </div>
          )}
        </div>
      </div>

      {/* 4. Order Workflow Flow */}
      <div className='section-container'>
        <div className='section-header-new'>
          <div className='section-title-new'>ความคืบหน้าคำสั่งซื้อ (Workflow)</div>
        </div>
        <div className='workflow-box'>
          <div className='workflow-steps'>
            <Link to='/myshop/seller/payment' className='wf-step'>
              <div className='wf-circle'>
                <i className='fe-credit-card'></i>
                {props.data_shoporderlist.filter(o => o.seller_shopid === props.permitdata.shop_id && o.order_status === 'IV_Req' && o.api_paymentstatus !== 'Success' && o.api_paymentstatus !== 'Cancel').length > 0 && 
                  <div className='wf-badge'>{props.data_shoporderlist.filter(o => o.seller_shopid === props.permitdata.shop_id && o.order_status === 'IV_Req' && o.api_paymentstatus !== 'Success' && o.api_paymentstatus !== 'Cancel').length}</div>}
              </div>
              <div className='wf-label'>รอชำระ</div>
            </Link>
            <Link to='/myshop/seller/deliver' className='wf-step'>
              <div className='wf-circle'>
                <i className='fe-box'></i>
                {summary_job.mustdeliver > 0 && <div className='wf-badge'>{summary_job.mustdeliver}</div>}
              </div>
              <div className='wf-label'>เตรียมจัดส่ง</div>
            </Link>
            <Link to='/myshop/seller/transport' className='wf-step'>
              <div className='wf-circle'>
                <i className='fe-truck'></i>
                {summary_job.ondeliver > 0 && <div className='wf-badge'>{summary_job.ondeliver}</div>}
              </div>
              <div className='wf-label'>กำลังจัดส่ง</div>
            </Link>
            <Link to='/myshop/seller/history' className='wf-step'>
              <div className='wf-circle'>
                <i className='fe-check-circle'></i>
              </div>
              <div className='wf-label'>สำเร็จแล้ว</div>
            </Link>
          </div>
        </div>
      </div>

      {/* 5. Analytics & Best Sellers */}
      <div className='section-container'>
        <div className='analytics-grid-new'>
          {/* Sales Chart */}
          <div className='chart-card'>
            <div className='section-title-new mb-1'>สถิติยอดขาย 7 วันล่าสุด</div>
            <div className='text-muted font-size-12 mb-3'>ภาพรวมรายได้รายสัปดาห์</div>
            <div className='bar-chart'>
              {['จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.', 'อา.'].map((day, i) => (
                <div key={i} className={`bar-item ${i === 6 ? 'active' : ''}`} style={{ height: `${summary_job.weeklySales[i] || 0}%` }}>
                  <div className='bar-label'>{day}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Best Sellers */}
          <div className='best-seller-list'>
            <div className='section-title-new mb-3'>สินค้าขายดี 5 อันดับ</div>
            {summary_job.bestSellers.length > 0 ? (
              summary_job.bestSellers.map((item, i) => (
                <div key={i} className='bs-item'>
                  <div className='bs-rank'>{i + 1}</div>
                  <img src={item.img || 'https://via.placeholder.com/44'} alt='' className='bs-img' />
                  <div className='bs-info'>
                    <div className='bs-name text-truncate' style={{ maxWidth: 140 }}>{item.name}</div>
                    <div className='bs-sales'>{item.sales} ชุดที่ขายได้</div>
                  </div>
                  <div className='text-primary font-weight-700 font-size-13'>นิยม</div>
                </div>
              ))
            ) : (
              <div className='text-center py-4 text-muted font-size-13'>ยังไม่มีข้อมูลการขาย</div>
            )}
          </div>
        </div>
      </div>

      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

MyShop_Seller_JobToDo.propTypes = {
  callback_datachanged: PropTypes.func,
};

export default MyShop_Seller_JobToDo;
